<template>
  <transition name="fade">
    <div
      v-if="visible"
      :class="['fixed top-4 md:top-20 flex items-center justify-center text-center text-black text-sm z-[9999]',
      isMobile
        ? 'left-1/2 -translate-x-1/2 w-[90%] max-w-md'
        : 'right-96 mt-3 w-[343px]'
    ]"      
      style="background: #C4D7FF; border-radius: 30px; height: 48px; padding: 12px 20px;  overflow: hidden;"
    >
      <span style="position: relative; z-index: 10;">{{ message }}</span>
      
      <!-- Progress bar - key forces re-render -->
      <div
        :key="visible"
        class="progress-bar"
        style="position: absolute; bottom: 0; left: 0; height: 4px; background: rgba(41, 49, 134, 1); border-radius: 0 0 0 30px;"
      />
    </div>
  </transition>
</template>
 
<script setup>
const { isMobile } = useDevice()
const props = defineProps({
  message: { type: String, required: true },
  visible: { type: Boolean, default: false },
})
</script>
 
<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.progress-bar {
  width: 100%;
  animation: progressBar 3000ms linear forwards;
}

@keyframes progressBar {
  from {
    width: 100%;
  }
  to {
    width: 0%;
  }
}
</style>
